import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {AGENCY_SIGNON} from '../constants/SalesChannels';

const TravelAgencyOptionsHOC = (C) => {
  class TravelAgencyOptionsCont extends Component {
    static show(props) {
      return (props.order.salesChannel === AGENCY_SIGNON);
    }

    constructor(props) {
      super(props);
      this.onMessageChange = this.onMessageChange.bind(this);
      this.onTypeChange = this.onTypeChange.bind(this);
      this.onUserIdChange = this.onUserIdChange.bind(this);
    }

    onMessageChange(name, value) {
      this.props.actions.updateAgencyMessage(value);
    }

    onTypeChange(name, value) {
      this.props.actions.updateOrderType(value);
    }

    onUserIdChange(name, value) {
      this.props.actions.updateAgencyUserId(value);
    }

    render() {
      return TravelAgencyOptionsCont.show(this.props) ? (
<C
  {...this.props}
  onMessageChange={this.onMessageChange}
  onTypeChange={this.onTypeChange}
  onUserIdChange={this.onUserIdChange}
/>
): null;
    }
  }

  TravelAgencyOptionsCont.propTypes = {
    actions: PropTypes.object.isRequired,
  };

  return TravelAgencyOptionsCont;
};

export default TravelAgencyOptionsHOC;